module.exports = __webpack_public_path__ + "static/media/natonCamera.082ce7a7.svg";